import React from 'react'

// Components
import ModalComponent from '../../../views/details/global/modalComponent'
import { ScheduleByDay } from './ScheduleByDay'

import { RegistrationFeesType } from '../../../../../models/event-fees/event-fees.interface'

import { MODAL_CONSTS } from '../../../../../const/modal-const'

// Types
type IProps = {
  show: boolean
  dataToPassOn: { data: RegistrationFeesType[]; scheduleBy: 'class' | 'rider' }
  handleModal: (showHide: boolean, typeOfModal: string, data?: any) => void
}

const EventSchedulingViewScheduleModal = ({ dataToPassOn, handleModal, show }: IProps) => {
  const closeModal = () => {
    handleModal(false, MODAL_CONSTS.VIEW_SCHEDULE_ORGANIZER)
  }

  return (
    <ModalComponent
      title="Schedule"
      show={show}
      fullScreen={true}
      fullWidth={true}
      onHide={closeModal}
      headingClassName="text-[25px] !text-SeabiscuitMainThemeColor !font-bold"
      type={MODAL_CONSTS.VIEW_SCHEDULE_ORGANIZER}
    >
      <ScheduleByDay scheduleBy={dataToPassOn.scheduleBy} registrationFees={dataToPassOn.data} />
    </ModalComponent>
  )
}

export default EventSchedulingViewScheduleModal
